import React, { useState } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "./user-dashboard-all-objective-drawer-side-bar.scss";
import Department from "../../../departments/departments";
import callIcon from "../../../../assets/icons/callIcon.svg";
import mailIcon from "../../../../assets/icons/mailIcon.png";
import { Avatar } from "@mui/material";

const UserDashboardAllObjectiveDrawerSideBar: any = (props: any) => {
  const { employeeId, profileData, onViewEmployee } = props;

  // Simulating API response

  let otherDepartmentMembers =
    profileData?.departmentMembers?.filter(
      (member: any) => member.employeeId !== employeeId,
    ) || [];
  const [showAllMembers, setShowAllMembers] = useState(false);

  return (
    <OverlayScrollbarsComponent
      options={{
        overflow: { x: "scroll", y: "scroll" },
        scrollbars: {
          theme: "os-theme-dark",
          autoHide: "scroll",
          autoHideDelay: 400,
        },
      }}
      className="profile-card-container"
    >
      {/* Profile Section */}
      <div className="profile-main">
        {profileData?.image ? (
          <img
            src={profileData.image}
            alt={profileData.name}
            className="profile-img"
          />
        ) : (
          <div className="profile-img-placeholder">
            <Avatar className="profile-avatar">{profileData?.initials}</Avatar>
          </div>
        )}
        <h2>{profileData?.name}</h2>
        <p className="role">
          {profileData?.role === "Super Admin" ? "Admin" : profileData?.role}
        </p>

        <div className="contact">
          <p className="phone">
            <img src={callIcon} alt="Call" className="icon" />
            {profileData?.phone}
          </p>
          <p className="email">
            <img src={mailIcon} alt="Email" className="icon" />
            {profileData?.email}
          </p>
        </div>

        <div className="tags">
          {profileData?.departments?.map((tag: any, idx: number) => (
            <Department
              key={idx + 1}
              departmentId={tag.id}
              departmentName={tag.name}
            />
          ))}
        </div>
      </div>
      {/* Reporting To */}
      <div className="reporting-section">
        <h4>Reporting to</h4>
        {profileData?.reportingTo ? (
          <div className="member-card">
            {profileData.reportingTo.image ? (
              <img
                src={profileData.reportingTo.image}
                alt={profileData.reportingTo.name}
                className="profile-img"
              />
            ) : (
              <Avatar className="profile-avatar">
                {profileData.reportingTo.initials}
              </Avatar>
            )}
            <div>
              <p className="name">{profileData.reportingTo.name}</p>
              <p className="role">
                {profileData.reportingTo.role === "Super Admin"
                  ? "Admin"
                  : profileData.reportingTo.role}
              </p>
            </div>
            <a
              href="/"
              className="view-link"
              onClick={(e) => {
                e.preventDefault();
                onViewEmployee(profileData.reportingTo.employeeId);
              }}
            >
              View
            </a>
          </div>
        ) : (
          <div
            className="member-card empty-card"
            style={{
              border: "1px solid #CFCEDA",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#CFCEDA",
              fontFamily: "Manrope, sans-serif",
              fontSize: "14px",
            }}
          >
            No Reporting
          </div>
        )}
      </div>
      {/* Department Members */}
      <div className="department-section">
        <h4>Department Members</h4>
        {otherDepartmentMembers.length > 0 ? (
          <>
            <div className="department-list">
              {(showAllMembers
                ? otherDepartmentMembers
                : otherDepartmentMembers.slice(0, 3)
              ).map((member: any) => (
                <div key={member.employeeId} className="member-card">
                  {member?.image ? (
                    <img
                      src={member?.image}
                      alt={member?.name}
                      className="profile-img"
                    />
                  ) : (
                    <Avatar className="profile-avatar">
                      {member?.initials}
                    </Avatar>
                  )}
                  <div>
                    <p className="name">{member.name}</p>
                    <p className="role">
                      {member.role === "Super Admin" ? "Admin" : member.role}
                    </p>
                  </div>
                  <a
                    href="/"
                    className="view-link"
                    onClick={(e) => {
                      e.preventDefault();
                      onViewEmployee(member.employeeId);
                    }}
                  >
                    View
                  </a>
                </div>
              ))}
            </div>

            {otherDepartmentMembers.length > 3 && (
              <div className="more-btn-box">
                <button
                  className="more-btn"
                  onClick={() => setShowAllMembers((prev) => !prev)}
                >
                  {showAllMembers
                    ? "Show Less"
                    : `+${otherDepartmentMembers.length - 3} More`}
                </button>
              </div>
            )}
          </>
        ) : (
          <div
            className="member-card empty-card"
            style={{
              border: "1px solid #CFCEDA",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#CFCEDA",
              fontFamily: "Manrope, sans-serif",
              fontSize: "14px",
            }}
          >
            No Department Members
          </div>
        )}
      </div>
    </OverlayScrollbarsComponent>
  );
};

export default UserDashboardAllObjectiveDrawerSideBar;
